// extracted by mini-css-extract-plugin
export default {"buttons":"src-client-modal-components-ModalButtons-___default__buttons___3LmyF"};